export default "__VITE_ASSET__bff1e145__"